import { NextPage } from 'next';
import Head from 'next/head';
import React, { useState, useEffect } from 'react';
import { sendForm } from 'src/services/from';

import { useBoolean } from '@sravni/react-utils';

import { Forms } from '../../components/Proposal/Forms';
import { Layout } from '../../components/Proposal/Layout';
import { ProposalHead } from '../../components/Proposal/ProposalHead';
import { IShareArticleForm } from '../../components/Proposal/ShareArticleForm';
import { IShareIdeaForm } from '../../components/Proposal/ShareIdeaForm';
import { SubmitSuccess } from '../../components/Proposal/SubmitSuccess';
import { FORM_TYPE } from '../../constants/proposal';
import { ISaveArticleFormParams, ISaveIdeaFormParams } from '../../interfaces/frombuilder';

const ProposalPage: NextPage = () => {
  const [sendedForm, setSendedForm] = useBoolean();
  const [error, setError] = useState();

  const submit = (type: FORM_TYPE, form: IShareArticleForm | IShareIdeaForm) => {
    let params: ISaveArticleFormParams | ISaveIdeaFormParams = form as ISaveArticleFormParams;

    sendForm(type, params).catch(setError).finally(setSendedForm.on);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Head>
        <title>Предложи статью для Сравни</title>
      </Head>
      <Layout>
        {sendedForm && !error ? (
          <SubmitSuccess />
        ) : (
          <>
            <ProposalHead />
            <Forms onSubmit={submit} />
          </>
        )}
      </Layout>
    </>
  );
};

export default ProposalPage;
